import { PlaylistListing } from "./PlaylistListing";

const PlaylistContent = () => (
	<main className="main">
		<PlaylistListing />
	</main>
);

export { PlaylistContent };
